import { RESET_STATE } from '../../reducer';

export const PROCESSING_VOLUME_TOOLTIP =
  'ReferredPartnersIndex/PROCESSING_VOLUME_TOOLTIP';
export const TRANSACTION_FEES_TOOLTIP =
  'ReferredPartnersIndex/TRANSACTION_FEES_TOOLTIP';
export const LOAD_INDEX = 'ReferredPartnersIndex/LOAD_INDEX';
export const SET_INDEX_DATA = 'ReferredPartnersIndex/SET_INDEX_DATA';
export const UPDATE_INDEX_DATA = 'ReferredPartnersIndex/UPDATE_INDEX_DATA';
export const LOAD_INDEX_FAILURE = 'ReferredPartnersIndex/LOAD_INDEX_FAILURE';
export const CHANGE_PAGINATOR_PAGE =
  'ReferredPartnersIndex/CHANGE_PAGINATOR_PAGE';
export const SET_PAGINATOR_TOTAL = 'ReferredPartnersIndex/SET_PAGINATOR_TOTAL';
export const SET_PER_PAGE_FILTER = 'ReferredPartnersIndex/SET_PER_PAGE_FILTER';
export const SET_SEARCH_FILTER = 'ReferredPartnersIndex/SET_SEARCH_FILTER';

export const ORDER_BY_PROCESSING_VOLUME =
  'ReferredPartnersIndex/ORDER_BY_PROCESSING_VOLUME';
export const ORDER_BY_TRANSACTION_FEE =
  'ReferredPartnersIndex/ORDER_BY_TRANSACTION_FEE';
export const ORDER_BY_NUM_MERCHANTS =
  'ReferredPartnersIndex/ORDER_BY_NUM_MERCHANTS';

export const DOWNLOAD_CSV = 'ReferredPartnersIndex/DOWNLOAD_CSV';
export const SET_CALENDAR_SAGA = 'ReferredPartnersIndex/SET_CALENDAR_SAGA';
// export const TOGGLE_FILTER = 'ReferredPartnersIndex/TOGGLE_FILTER';
// export const SET_STATUS_FILTER = 'ReferredPartnersIndex/SET_STATUS_FILTER';
export const SET_CALENDAR_START_FILTER =
  'ReferredPartnersIndex/SET_CALENDAR_START_FILTER';
export const SET_CALENDAR_END_FILTER =
  'ReferredPartnersIndex/SET_CALENDAR_END_FILTER';
export const CLEAR_CALENDAR_FILTER =
  'ReferredPartnersIndex/CLEAR_CALENDAR_FILTER';
export const TOGGLE_CALENDAR_FILTER =
  'ReferredPartnersIndex/TOGGLE_CALENDAR_FILTER';
// export const ORDER_BY_AMOUNT = 'ReferredPartnersIndex/ORDER_BY_AMOUNT';

export const loadReferredPartnersIndex = params => ({
  type: LOAD_INDEX,
  params
});

export const setReferredPartnersIndex = payload => ({
  type: SET_INDEX_DATA,
  payload
});

export const loadReferredPartnersIndexFailure = () => ({
  type: LOAD_INDEX_FAILURE
});

export const changePage = pageNumber => ({
  type: CHANGE_PAGINATOR_PAGE,
  pageNumber
});

export const setPaginatorTotal = paginatorTotal => ({
  type: SET_PAGINATOR_TOTAL,
  paginatorTotal
});

export const orderByProcessingVolume = orderByState => ({
  type: ORDER_BY_PROCESSING_VOLUME,
  orderByState
});

export const orderByTransactionFee = orderByState => ({
  type: ORDER_BY_TRANSACTION_FEE,
  orderByState
});

export const orderByNumMerchants = orderByState => ({
  type: ORDER_BY_NUM_MERCHANTS,
  orderByState
});

export const downloadCsv = path => ({
  type: DOWNLOAD_CSV,
  path
});

export const setCalendarSaga = () => ({
  type: SET_CALENDAR_SAGA
});

// export const toggleFilter = () => ({
//   type: TOGGLE_FILTER
// });

// export const setStatusFilter = statusFilter => ({
//   type: SET_STATUS_FILTER,
//   statusFilter
// });

export const setPerPageFilter = perPageFilter => ({
  type: SET_PER_PAGE_FILTER,
  perPageFilter
});

export const setSearchFilter = searchValue => ({
  type: SET_SEARCH_FILTER,
  searchValue
});

export const setCalendarStartFilter = calendarStart => ({
  type: SET_CALENDAR_START_FILTER,
  calendarStart
});

export const setCalendarEndFilter = calendarEnd => ({
  type: SET_CALENDAR_END_FILTER,
  calendarEnd
});

export const clearCalendarFilter = () => ({
  type: CLEAR_CALENDAR_FILTER
});

export const toggleCalendarFilter = () => ({
  type: TOGGLE_CALENDAR_FILTER
});

// export const orderByAmount = orderByState => ({
//   type: ORDER_BY_AMOUNT,
//   orderByState
// });

const displayActiveFilter = (state, key) => ({
  ...state,
  calendarFilterState: false,
  [key]: !state[key]
});

const initialState = {
  loading: true,
  failedLoad: false,
  currentPage: 1,
  previouslyVisited: [1],
  perPageFilter: 10,
  searchValue: '',

  orderByProcessingVolumeState: 0,
  orderByTransactionFeeState: 0,
  orderByNumMerchantsState: 0,
  orderByType: null,

  // toggleFilterState: true,
  // // typeFilter: undefined,
  // statusFilter: undefined,
  calendarFilterState: false,
  referral_details: [],
  calendarStart: null,
  calendarEnd: null
  // isMobile: false,
  // orderByState: 0,
  // orderByType: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_INDEX_DATA:
      return {
        ...state,
        referral_details: action.payload.referral_details,
        loading: false
      };
    case UPDATE_INDEX_DATA:
      return {
        ...state,
        updateTableLoading: true,
        ...state.directMerchant,
        orderByProcessingVolumeState: 0,
        orderByTransactionFeeState: 0,
        orderByNumMerchantsState: 0,
        orderByType: null
      };
    case LOAD_INDEX_FAILURE:
      return {
        ...state,
        failedLoad: true
      };
    case CHANGE_PAGINATOR_PAGE:
      return {
        ...state,
        currentPage: action.pageNumber,
        previouslyVisited: state.previouslyVisited.includes(action.pageNumber)
          ? state.previouslyVisited
          : [...state.previouslyVisited, action.pageNumber]
      };
    case SET_PAGINATOR_TOTAL:
      return {
        ...state,
        paginatorTotal: action.paginatorTotal
      };
    case SET_PER_PAGE_FILTER:
      return {
        ...state,
        perPageFilter: action.perPageFilter,
        expandedRow: null,
        previouslyVisited: [1],
        currentPage: 1
      };

    case SET_SEARCH_FILTER:
      return {
        ...state,
        searchValue: action.searchValue
      };

    case ORDER_BY_PROCESSING_VOLUME:
      return {
        ...state,
        orderByProcessingVolumeState: action.orderByState,
        orderByTransactionFeeState: 0,
        orderByNumMerchantsState: 0,
        orderByType: 'total_processing_vol_usd'
      };
    case ORDER_BY_TRANSACTION_FEE:
      return {
        ...state,
        orderByProcessingVolumeState: 0,
        orderByTransactionFeeState: action.orderByState,
        orderByNumMerchantsState: 0,
        orderByType: 'total_fees_usd'
      };
    case ORDER_BY_NUM_MERCHANTS:
      return {
        ...state,
        orderByProcessingVolumeState: 0,
        orderByTransactionFeeState: 0,
        orderByNumMerchantsState: action.orderByState,
        orderByType: 'total_merchants'
      };
    case SET_CALENDAR_START_FILTER:
      return {
        ...state,
        expandedRow: null,
        previouslyVisited: [1],
        calendarStart: action.calendarStart
      };
    case SET_CALENDAR_END_FILTER:
      return {
        ...state,
        expandedRow: null,
        previouslyVisited: [1],
        calendarEnd: action.calendarEnd
      };
    case CLEAR_CALENDAR_FILTER:
      return {
        ...state,
        expandedRow: null,
        previouslyVisited: [1],
        calendarStart: null,
        calendarEnd: null,
        calendarFilterState: false
      };
    case RESET_STATE:
      return {
        ...state,
        ...initialState
      };
    case TOGGLE_CALENDAR_FILTER:
      return displayActiveFilter(state, 'calendarFilterState');
    default:
      return state;
  }
};
